var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.08
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_307_7519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0703 8H25.961L19.9453 13.9562C17.7668 16.1121 14.2348 16.1121 12.0547 13.9562L6.03674 8H8.92971L13.5 12.5246C14.1659 13.1809 15.0633 13.5488 15.9983 13.5488C16.9332 13.5488 17.8306 13.1809 18.4965 12.5246L23.0703 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89258 24.5625H6L12.0547 18.5695C14.2332 16.4137 17.7652 16.4137 19.9453 18.5695L26 24.5625H23.1094L18.5 20.0012C17.8341 19.3449 16.9367 18.977 16.0018 18.977C15.0668 18.977 14.1694 19.3449 13.5035 20.0012L8.89258 24.5625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_307_7519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.5625,
    fill: "white",
    transform: "translate(6 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrp);
export default __webpack_public_path__ + "static/media/XRP.1b3f47ffff42f73b529859b35733b154.svg";
export { ForwardRef as ReactComponent };